import { useApi, PaginatedResponse } from '@/api';
import { CardList, LinkButton, Link, ListSkeleton } from '@/components';
import {
  Flex,
  WalletAddress,
  CurrencyValue,
  ListItem
} from '@blockanalitica/ui';

type WalletResponse = {
  wallet_address: string;
  underlying_symbol: string;
  datetime: string;
  order_index: string;
  balance: string;
};

export default function TopSuppliers({
  marketAddress,
  collateralAddress,
  underlyingSymbol,
  network,
  ...rest
}: {
  marketAddress: string;
  collateralAddress: string;
  underlyingSymbol: string;
  network: string;
}) {
  const [data, error] = useApi<PaginatedResponse<WalletResponse[]>>({
    url: `/markets/${marketAddress}/collaterals/${collateralAddress}/wallets/`,
    queryParams: {
      limit: '4',
      sort: '-balance'
    }
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <ListSkeleton />;
  }

  return (
    <CardList
      title="Top Wallets"
      action={
        <LinkButton to="wallets" variant="secondary">
          view all
        </LinkButton>
      }
      {...rest}>
      {data['results'].length > 0 &&
        data['results'].map((row) => (
          <ListItem
            // @ts-ignore
            as={Link}
            key={row.wallet_address}
            to={`../borrowers/${row.wallet_address}`}
            relative="path">
            <Flex justifyContent="space-between" alignItems="center">
              <WalletAddress address={row.wallet_address} />
              <CurrencyValue
                value={row.balance}
                options={{
                  iconSize: '1',
                  currency: {
                    name: underlyingSymbol,
                    address: collateralAddress,
                    network: network
                  }
                }}
              />
            </Flex>
          </ListItem>
        ))}
    </CardList>
  );
}
